import { useDispatch, useSelector } from "react-redux";
import atgGamesSlice from "./atgGamesSlice";

function useAtgGames() {
  const { games, gameUrl } = useSelector((state) => {
    return state.atgGames;
  });
  const dispatch = useDispatch();

  function setAtgGames(newAtgGames) {
    dispatch(atgGamesSlice.actions.setAtgGames(newAtgGames));
  }

  function setAtgGameUrl(newAtgGameUrl) {
    dispatch(atgGamesSlice.actions.setAtgGameUrl(newAtgGameUrl));
  }

  return { games, gameUrl, setAtgGames, setAtgGameUrl };
}

export default useAtgGames;
